import React, { useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AIResponseError from '../../common/AIResponseError';
import BreadcrumbCrumb from '../../common/Breadcrumbs/BreadcrumbCrumb';
import PageBreadcrumbs from '../../common/Breadcrumbs/PageBreadcrumbs';
import { TruncatedTitle } from '../../common/TruncatedTitle';
import StudyDeckHeader from './StudyDeckHeader';
import StudyDeckBody from './StudyDeckBody';

function StudyDeck() {
  const navigate = useNavigate();
  const isImpersonating = useSelector((state) => state.impersonation.isImpersonating);
  const courseId = useSelector((state) => state.course.courseId);
  const showBanner = isImpersonating || !!courseId;
  const { deck, isLoading, loadError } = useOutletContext();
  const [cardCounter, setCardCounter] = useState('');

  return (
    // The page fills the screen, so it has to give the banner its height back —
    // the same way the deck's other pages and the quiz's do.
    <Box className={'mss__studyDeck' + (showBanner ? ' impersonating' : '')}>
      <PageBreadcrumbs rootTo="../../.." isVisible={!loadError}>
        <BreadcrumbCrumb isLoading={isLoading} to=".." width={100}>
          <TruncatedTitle name={deck?.title} isFocusable={false} variant="inherit" />
        </BreadcrumbCrumb>
        <Typography>Study</Typography>
      </PageBreadcrumbs>

      {isLoading && (
        <Skeleton
          id="studyDeck__skeleton_loading"
          variant="rectangular"
          height={240}
          sx={{ mt: '1rem' }}
        />
      )}

      {loadError && (
        <AIResponseError
          message={loadError}
          onGoToDashboard={() => navigate('../../..', { relative: 'path' })}
        />
      )}

      {!isLoading && !loadError && (
        <>
          <StudyDeckHeader deck={deck} cardCounter={cardCounter} />
          <Box className="mss__box">
            <StudyDeckBody deck={deck} onCardChange={setCardCounter} />
          </Box>
        </>
      )}
    </Box>
  );
}

export default StudyDeck;
